export default class NewsletterForms {
  constructor() {
    this.prefillNewsletterEmail();
    this.bindShopifyForms();
  }

  prefillNewsletterEmail() {
    const params = new URLSearchParams(window.location.search);
    const email = params.get('email');

    if (!email) return;

    document.querySelectorAll('[js-newsletter-email-input]').forEach((input) => {
      if (!(input instanceof HTMLInputElement)) return;
      if (input.value.trim() !== '') return;
      input.value = email;
    });
  }

  bindShopifyForms() {
    document.querySelectorAll('.ird-newsletter__form').forEach((form) => {
      if (!(form instanceof HTMLFormElement)) return;

      form.addEventListener('submit', () => {
        const profession = form.querySelector('[js-newsletter-profession]');
        const tags = form.querySelector('[js-newsletter-tags]');
        if (!(profession instanceof HTMLSelectElement) || !(tags instanceof HTMLInputElement)) return;

        const professionValue = profession.value.trim();
        tags.value = professionValue ? `newsletter, ${professionValue}` : 'newsletter';
      });
    });
  }
}
